module.exports = __webpack_public_path__ + "img/fb_1@4x.57c0a80b.png";